module.exports = __webpack_public_path__ + "static/media/1017340.3efd98ba.jpg";